var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8782 10.6381V13.3059C14.8782 13.6597 14.7377 13.999 14.4875 14.2492C14.2374 14.4993 13.8981 14.6398 13.5443 14.6398H4.20695C3.85318 14.6398 3.5139 14.4993 3.26374 14.2492C3.01358 13.999 2.87305 13.6597 2.87305 13.3059V10.6381",
    stroke: "white",
    strokeWidth: 2.00086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54053 7.30334L8.8753 10.6381L12.2101 7.30334",
    stroke: "white",
    strokeWidth: 2.00086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87549 10.6381V2.63464",
    stroke: "white",
    strokeWidth: 2.00086,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.4e5fcb8e94ed06b2c12aad1f8fb45651.svg";
export { ForwardRef as ReactComponent };